<template>
  <div style="overflow-x: hidden;">
    <md-toolbar md-elevation="0" class="md-transparent" style="background: white!important;height: 52px;">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h5>{{ $t($route.name) }}</h5>
        </div>
        <div class="md-toolbar-section-end">
        <top></top>
        </div>
      </div>
    </md-toolbar>
    <div class="row xisobot" v-if="rules.length>0">
      <div>
        <label for="">{{$t('Отчет товары')}}</label><br>
        <router-link v-if="rules[23].see==true" class="btn" target="_blank" :to="{ path: rules[23].doc_for_rule.path}">
          <b-icon :icon="rules[23].doc_for_rule.icon"></b-icon> {{$t(rules[23].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[24].see==true" class="btn" target="_blank" :to="{ path: rules[24].doc_for_rule.path}">
          <b-icon :icon="rules[24].doc_for_rule.icon"></b-icon> {{$t(rules[24].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[29].see==true" class="btn" target="_blank" :to="{ path: rules[29].doc_for_rule.path}">
          <b-icon :icon="rules[29].doc_for_rule.icon"></b-icon> {{$t(rules[29].doc_for_rule.name)}}
        </router-link>
      </div>
      <div>
        <label for="">{{$t('Отчет контрагента')}}</label><br>
        <router-link v-if="rules[27].see==true" class="btn" target="_blank" :to="{ path: rules[27].doc_for_rule.path}">
          <b-icon :icon="rules[27].doc_for_rule.icon"></b-icon> {{$t(rules[27].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[28].see==true" class="btn" target="_blank" :to="{ path: rules[28].doc_for_rule.path}">
          <b-icon :icon="rules[28].doc_for_rule.icon"></b-icon> {{$t(rules[28].doc_for_rule.name)}}
        </router-link>
      </div>
      <div>
        <label for="">{{$t('Отчет касса')}}</label><br>
        <router-link v-if="rules[22].see==true" class="btn" target="_blank" :to="{ path: rules[22].doc_for_rule.path}">
          <b-icon :icon="rules[22].doc_for_rule.icon"></b-icon> {{$t(rules[22].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[19].see==true" class="btn" target="_blank" :to="{ path: rules[19].doc_for_rule.path}">
          <b-icon :icon="rules[19].doc_for_rule.icon"></b-icon> {{$t(rules[19].doc_for_rule.name)}}
        </router-link>
      </div>
      <div>
        <label for="">{{$t('Отчет ходим')}}</label><br>
        <span v-for="(item, index) in rules" v-if="item.doc_for_rule.type=='report_user'">
          <router-link v-if="item.see==true" class="btn" target="_blank" :to="{ path: item.doc_for_rule.path}">
            <b-icon :icon="item.doc_for_rule.icon"></b-icon> {{$t(item.doc_for_rule.name)}}
          </router-link>
        </span>
      </div>
      <div>
        <label for="">{{$t('Отчет прибыль-убытки')}}</label><br>
        <router-link v-if="rules[20].see==true" class="btn" target="_blank" :to="{ path: rules[20].doc_for_rule.path}">
          <b-icon :icon="rules[20].doc_for_rule.icon"></b-icon> {{$t(rules[20].doc_for_rule.name)}}
        </router-link>
        <router-link  v-if="rules[25].see==true" class="btn" target="_blank" :to="{ path: rules[25].doc_for_rule.path}">
          <b-icon :icon="rules[25].doc_for_rule.icon"></b-icon> {{$t(rules[25].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[26].see==true" class="btn" target="_blank" :to="{ path: rules[26].doc_for_rule.path}">
          <b-icon :icon="rules[26].doc_for_rule.icon"></b-icon> {{$t(rules[26].doc_for_rule.name)}}
        </router-link>
        <router-link v-if="rules[21].see==true" class="btn" target="_blank" :to="{ path: rules[21].doc_for_rule.path}">
          <b-icon :icon="rules[21].doc_for_rule.icon"></b-icon> {{$t(rules[21].doc_for_rule.name)}}
        </router-link>
      </div>    
      <div>
        <label for="">Рееcтер</label><br>
        <span v-for="(item, index) in rules" v-if="item.doc_for_rule.type=='report_rester'">
          <router-link v-if="item.see==true" class="btn" target="_blank" :to="{ path: item.doc_for_rule.path}">
            <b-icon :icon="item.doc_for_rule.icon"></b-icon> {{$t(item.doc_for_rule.name)}}
          </router-link>
        </span>
      </div>    
    </div>
</div>
</template>
<script>
import Top from "../Layout/Top.vue";

export default {
  data() {
    return {
      rules:[],
    };
  },
  components: {Top},
  computed: {
  },
  mounted() {
    this.rules = JSON.parse(localStorage.getItem("rules"));
  },
  methods: {
    Href(href){
      var tes=window;
      const routeData = this.$router.resolve({
  name: "Товар хисоботи"
});
     tes.open(routeData.href, "_blank", "width=1400, height=1000");
    }
  }
};
</script>
